// state.js

export default {
    systemTypesList: [],
};
